import { Component, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

// Confirmación del cierre de jornadas (change 2026-10-notificacion-jornadas-sin-salida).
// Devuelve true al confirmar y false al cancelar. Se abre con windowClass 'modal-confirmar-cierre':
// los estilos (sin encapsulación) van todos bajo esa clase y no afectan a otros modales.
@Component({
  selector: 'modal-confirmar-cierre',
  styleUrls: [('./modalConfirmarCierre.scss')],
  templateUrl: './modalConfirmarCierre.html',
  encapsulation: ViewEncapsulation.None
})
export class ModalConfirmarCierre {

  header: string;
  resumen: { etiqueta: string, valor: string }[] = [];
  nota: string;

  constructor(private activeModal: NgbActiveModal) {
  }

  confirmar() {
    this.activeModal.close(true);
  }

  cancelar() {
    this.activeModal.close(false);
  }
}



// WEBPACK FOOTER //
// /app/src/app/theme/components/modals/components/modalConfirmarCierre/modalConfirmarCierre.component.ts